import { apiClient } from 'client/core/network/apiClient';
import { ISoapLdapDto } from 'common/dto/SoapLdapDto';

export const SoapLdapApi = {
  login: (data: ISoapLdapDto) => apiClient.post('/auth/soap-ldap', data)
};
